import * as types from './types'

export default {
  [types.SET_DEVICES](state, data) {
    state.devices = []
    if (data !== null && data !== undefined) {
      state.devices = data
    }
  },
  [types.SET_PAIRINFO](state, data) {
    state.pairinfo = data
  },
  [types.SET_DEVICE_STATS](state, stats) {
    state.stats = stats.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/simulator/mutations.js